import { Component, computed, EventEmitter, Input, Output } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { GlobalConstants } from 'src/app/common/global';
import { Services } from 'src/app/services/api.service';
import { Router } from '@angular/router';
import { MembershipService } from '../membership.service';
import { NgxBarcode6Module } from 'ngx-barcode6';
import { CommonModule } from '@angular/common';
import { ModalChangePhotoComponent } from 'src/app/components/modal-change-photo/modal-change-photo.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ProfileService } from 'src/app/services/profile.service';
import { ErrorMessageService } from 'src/app/services/error-message.util';
import { ModalService } from 'src/app/services/modal.service';
import { ModalNames } from 'src/app/common/modal.config';
import { PaymentComponent } from 'src/app/components/payment/payment.component';
import { DeliveryComponent } from 'src/app/components/delivery/delivery.component';
import { OrderService } from 'src/app/services/getOrder.service';
import { CartInfoBoxComponent } from 'src/app/components/cart-info-box/cart-info-box.component';

@Component({
  selector: 'app-memberhsip-card',
  templateUrl:  `./${environment.pageFolder}/membership-card.${environment.pageFolder}.component.html`,
  styleUrls:  [`./${environment.pageFolder}/membership-card.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [NgxBarcode6Module, CommonModule, ModalChangePhotoComponent, FormsModule, TranslateModule, PaymentComponent, DeliveryComponent, CartInfoBoxComponent]
})

export class MemberhsipCardComponent {
  @Input() membershipCard: any;
  @Output() callGetMembershipFunction = new EventEmitter<string>();
  @Output() showConnectMembership = new EventEmitter<void>();
  showContainer: string = "";
  loader = document.getElementById("loader-container");
  finishPaymentUrl: string = "";
  newMembershipId: string = "";
  renewErrorMessage: string = "";
  ticketPdf: string = "";
  url:any;
  pictureProfile: string = "";
  showChangePhotoModal: boolean = false;
  commissionerCode: any;
  showInputFieldForCommissionerCode: boolean = false;
  connectCommissionerErrorMessage: string = "";
  page = environment.page;
  orderId: number = 0;
  showDelivery: boolean = false;
  showBarcodeInModal: boolean = false;
  public readonly modalNamesEnum = ModalNames;
  readonly isMembershipCardModalOpen = computed(() => this.modalService.modalsState().get(ModalNames.MembershipCard) ?? false);
  order: any;

  constructor(
    private http: HttpClient,
    private Services: Services,
    private router : Router,
    private membershipService: MembershipService,
    private profileService: ProfileService,
    private errorMessageService: ErrorMessageService,
    public modalService: ModalService,
    private orderService: OrderService
  ) {
  }
  
  ngOnInit() {
    if(this.membershipCard.forPayment) {
      this.showContainer = "forPayment";
      this.finishPaymentUrl = `/buy-membership/${this.membershipCard.transactionId}`;
    } else if(this.membershipCard.isActive || (!this.membershipCard.isActive && this.membershipCard.isRenewable)) {
      this.showContainer = "active";
    } else if(!this.membershipCard.applicationComplete) {
      this.showContainer = "applicationNotCompleted";
    } else if(!this.membershipCard.verificationComplete) {
      this.showContainer = "verificationInProgress";
    } else if(!this.membershipCard.approved) {
      this.showContainer = "notApproved";
    } else if(!this.membershipCard.isActive) {
      if(this.membershipCard.verificationComplete && this.membershipCard.approved) {
        this.showContainer = "cantRenewButCanBuy";
      } else {
        this.showContainer = "cantRenew";
      }
    } else {
      this.showContainer = "cantRenew";
    }

    this.pictureProfile = this.membershipCard.pictureProfile ? ("data:image/jpeg;base64," + this.membershipCard.pictureProfile) : "img/membership/clan.png";
  }

  renewMembership(membershipCard:any) {
    let body: any = {}
    let endpoint = (membershipCard.ownerUser === "D") ? "" : "/others";

    endpoint = "";

    this.http.post<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/memberships/renew/${this.membershipCard.id}${endpoint}`, body, GlobalConstants.headersCentral).subscribe({
      next: data => {
        let response:any = data;
        if(!response.data.documentComplete) {
          sessionStorage.setItem("acceptTerms", "true");
          document.location = `${environment.redirectUrl}/buy-membership/${response.data.transId}`;
          this.showContainer = "";
        } else {
          this.showContainer = "applicationNotCompleted";
        }
        this.newMembershipId = response.data.membershipId;
        this.membershipCard.id = response.data.membershipId;

        this.orderId = response.data.transId;
        this.orderService.getOrder(this.orderId, false).subscribe({
          next: (order) => {
            this.order = order;
            this.showDelivery = true;
            /* if(order.transactionInfo.deliveryDataSubmitted) {
            } else {
              this.showDelivery = true;
            } */
            this.showBarcodeInModal = false;
          }
        });
        this.modalService.openModal(this.modalNamesEnum.MembershipCard);

        this.renewErrorMessage = "";
        this.loader!.style.display = "none";
      },
      error: error => {
        if(error.status === 401) {
          document.location = ``;
        } else if(error.error.errors[0].code === "ORA-20149") {
          this.renewErrorMessage = this.errorMessageService.getErrorMessage("purchaseContinuationDisabled");
        } else if(error.error.errors[0].code === "ORA-20150") {
          this.renewErrorMessage = this.errorMessageService.getErrorMessage("purchaseInProgress");
        } else {
          this.renewErrorMessage = "Greška!";
        }
        this.loader!.style.display = "none";
      }
    })
  }

  removeAutoRenewMembership(membershipCard: any) {
    this.Services.autoRenewalMembershipService(this.membershipCard.transactionId, !membershipCard.autoRenewal).subscribe({
      next: data => {
        this.callGetMembershipFunction.emit('eventDesc');
      }
    })
  }

  downloadApplicationForm() {
    this.loader!.style.display = "flex";

    this.http.get<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/memberships/applicationForm/${this.membershipCard.id}`, GlobalConstants.headersCentral).subscribe({
      next: data => {
        let response:any = data;
        let applicationForm = "data:application/pdf;base64," + response.data;
        const byteArray = new Uint8Array(atob(response.data).split('').map(char => char.charCodeAt(0)));
        let blob = new Blob([byteArray], {type: 'application/pdf'});
        let url = window.URL.createObjectURL(blob);
        //window.open(url);

        //let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

        const fileName = '-pristupnica.pdf';
        const downloadLink = document.createElement('a');
        downloadLink.href = url;
        downloadLink.download = fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        /* if(isSafari) {
        } */
        
        this.loader!.style.display = "none";
      },
      error: error => {
        this.loader!.style.display = "none";
      }
    })
  }

  uploadApplicationForm(event:any, transId: number) {
    let selectedFile = event.target.files[0];
    const reader = new FileReader();

    if(selectedFile.type === "application/pdf") {
      reader.onload = () => {
        let body = {
          document: reader.result?.toString().split("base64,")[1]
        }

        this.http.post<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/memberships/applicationForm/${this.membershipCard.id}`, body, GlobalConstants.headersCentral).subscribe({
          next: () => {
            sessionStorage.setItem("acceptTerms", "true");
            this.callGetMembershipFunction.emit('eventDesc');
          },
          error: error => {
            this.loader!.style.display = "none";
          }
        })
      };

      reader.readAsDataURL(selectedFile);
    } else if(selectedFile.type.startsWith('image/')){
      reader.onloadend = () => {
        const base64String = reader.result as string;
        const image = new Image();
        image.src = base64String;
        image.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          const maxWidth = 1000;
          const maxHeight = 1000;
          let newWidth = image.width;
          let newHeight = image.height;
  
          if (newWidth > maxWidth || newHeight > maxHeight) {
            if (newWidth > newHeight) {
              newHeight = Math.round((newHeight * maxWidth) / newWidth);
              newWidth = maxWidth;
            } else {
              newWidth = Math.round((newWidth * maxHeight) / newHeight);
              newHeight = maxHeight;
            }
          }
  
          canvas.width = newWidth;
          canvas.height = newHeight;
          ctx!.drawImage(image, 0, 0, newWidth, newHeight);
  
          const compressedBase64 = canvas.toDataURL('image/jpeg', 0.9);
  
          let body = {
            document: compressedBase64.split("data:image/jpeg;base64,")[1]
          }
  
          this.http.post<any>(`${environment.apiUrl}/conn/${environment.connId}/v1/memberships/applicationForm/${this.membershipCard.id}`, body, GlobalConstants.headersCentral).subscribe({
            next: () => {
              sessionStorage.setItem("acceptTerms", "true");
              this.callGetMembershipFunction.emit('eventDesc');
            },
            error: error => {
              this.loader!.style.display = "none";
            }
          })
        };
      };
    } else {
      alert("Greška pri učitavanju dokumenta")
    }
    
    reader.readAsDataURL(selectedFile);
  }

  getTransactionInPdf(transID: string, transactionType: string) {
    this.profileService.getTransactionAndOpenPdf(transID, transactionType, this.loader!);
  }

  submitCommisionarId() {
    this.loader!.style.display = "flex";

    this.membershipService.submitcCmmissionerId(this.membershipCard.transactionId, this.commissionerCode).subscribe({
      next: (data) => {
        if(data.data.success) {
          this.connectCommissionerErrorMessage = "";
          this.callGetMembershipFunction.emit('eventDesc');
        } else if(!data.data.success && data.data.code === "ORA-100") {
          this.connectCommissionerErrorMessage = "Unesena šifra ne postoji, molimo da se obratite Vašem povjereniku ili nastavite dalje bez unosa šifre povjerenika.";
          this.loader!.style.display = "none";
        } else {
          this.connectCommissionerErrorMessage = "Greška!";
          this.loader!.style.display = "none";
        }
      },
      error: error => {
        this.loader!.style.display = "none";
      }
    })
  }

  showBarcode() {
    this.showBarcodeInModal = true;
    this.modalService.openModal(this.modalNamesEnum.MembershipCard);
  }

  goToRenewMembership() {
    this.router.navigate([this.finishPaymentUrl]);
  }

  showConnectMembershipComponent() {
    this.showConnectMembership.emit();
  }

  openChangePhotoModal() {
    this.showChangePhotoModal = true;
  }

  closeModalChangePhoto() {
    this.showChangePhotoModal = false;
  }

  emitOnSubmitDeliveryData() {
    this.orderService.getOrder(this.orderId, true).subscribe({
      next: (order) => {
        this.order = order;
        this.showDelivery = false;
      }
    });
  }
}
